import { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
import { useSelector } from 'react-redux';
// import { ThunkDispatch } from 'redux-thunk';
import { AxiosError } from 'axios';

import AppInput from '../../UI/AppInput';
import RadioButtons from '../../UI/RadiouButtons';
import Checkbox from '../../UI/Checkbox';
import Button from '../../UI/Button';

import { CALENDAR, EMAIL, TEL, TEXT } from '../../app_constants';
import bemClassName from '../../utils/bem';

import './index.scss';
// import {
//  fetchCheckFioValidate,
//  fetchCheckNameValidate,
//  fetchCheckSurnameValidate,
// } from '../../store/reducers/profile/personalDataSlice';
import { RootState } from '../../store';
import PrivateData from '../../API/PrivateData';
import Validate from '../../API/Validate';
import { formatedDateDayBirdh } from '../../utils/date';

const personalData = bemClassName('personal-data');

const PersonalData = () => {
  // const [dataListName, setDataListName] = useState<Array<string>>([]);
  // const [dataListSurname, setDataListSurname] = useState<Array<string>>([]);
  const [profileData, setProfailData] = useState({});

  const [surname, setSurname] = useState<string>();
  const [name, setName] = useState<string>();
  const [middlename, setMiddlename] = useState<string>();

  const [company, setCompanyValue] = useState<string>();

  const [email, setEmail] = useState<string>();
  const [emailIsValid, setEmailIsValid] = useState<boolean>();
  // const [emailDomainArray, setEmailDomainArray] = useState<Array<string>>();

  const [genderValue, setGenderValue] = useState<string>();

  const [phoneNumber, setPhoneNumber] = useState<string>();
  const [additionalPhoneNumber, setAdditionalPhoneNumber] = useState<string>();
  const [phoneIsValid, setPhoneIsValid] = useState<boolean>();
  const [phoneAdditionalIsValid, setPhoneAdditionalIsValid] = useState<boolean>();
  // const [phoneErrorText, setPhoneErrorText] = useState<string>('');

  // const [cardIsValid, setCardIsValid] = useState<boolean>();
  const [bonusCard, setBonusCard] = useState<string>();
  const [bonusCardIsValid, setBonusCardIsValid] = useState<boolean>();
  const [dateOfBirth, setDateOfBirth] = useState<string>();
  const [disabledButton, setDisabledButton] = useState<boolean>(false);
  const [checkbox, setCheckBox] = useState<boolean>();
  const [additionalPhone, setAdditionalPhone] = useState<boolean>(false);
  const [errorBoolean, setErrorBoolean] = useState<boolean>(false);

  // const fioHelperArray = useSelector((state: RootState) => state.personalData.fioHelperArray);
  const isLogin = useSelector((state: RootState) => state.autorizationStatus.isLogin);

  // const dispatchAsync = useDispatch<ThunkDispatch<any, any, any>>();

  const handleSaveUserData = () => {
    if (profileData) {
      setDisabledButton(false);
      PrivateData.getPrivateEditUserDate(profileData).then(() => setDisabledButton(true));
    }
  };

  const handleSetSurname = (value: string) => {
    setSurname(value);
  };

  const handleSetName = (value: string) => {
    setName(value);
  };

  const handleSetMiddlename = (value: string) => {
    setMiddlename(value);
  };

  const handleSetPhoneNumber = (value: string) => {
    setPhoneNumber(value);
  };

  const handleSetAdditionalPhoneNumber = (value: string) => {
    setAdditionalPhoneNumber(value);
  };
  const handleSetEmail = (value: string) => {
    setEmail(value);
  };

  const handleSetGenderValue = (value: string) => {
    setGenderValue(value);
  };

  const handleSetCompanyValue = (value: string) => {
    setCompanyValue(value);
  };

  const handleSetBonus = (value: string) => {
    setBonusCard(value);
  };

  const handleSetBirthDay = (value: string) => {
    if (value) {
      if (value.length > 10) {
        setDateOfBirth(formatedDateDayBirdh(value));
      } else {
        // const day = value.slice(0, 2);
        // const month = value.slice(3, 5);
        // const year = value.slice(6, 10);
        // setDateOfBirth(formatedDateDayBirdh(`${month}.${day}.${year}`));
        setDateOfBirth(value);
      }
    }
  };

  const handleSetCheckBox = () => {
    if (!checkbox) {
      setCheckBox(true);
    } else {
      setCheckBox(false);
    }
  };

  const handleAddetAdditionalTel = () => {
    if (!additionalPhone) {
      setAdditionalPhone(true);
    } else {
      setAdditionalPhone(false);
      setAdditionalPhoneNumber('');
    }
  };

  useEffect(() => {
    if (
      additionalPhoneNumber &&
      additionalPhoneNumber !== undefined &&
      additionalPhoneNumber !== null
    ) {
      setAdditionalPhone(true);
    }
  }, [additionalPhoneNumber]);

  useEffect(() => {
    const abortControllerPhone = new AbortController();
    if (phoneNumber) {
      (async () => {
        try {
          const responseData = await Validate.checkPhone(phoneNumber, abortControllerPhone.signal);
          setPhoneIsValid(true);
          if (responseData.international) {
            setPhoneNumber(responseData.international);
          }
        } catch (error) {
          const err = error as Error | AxiosError;
          if (err.name === 'AbortError') {
            // return error;
          } else {
            setPhoneIsValid(false);
          }
        }
      })();
    }
    return () => {
      abortControllerPhone.abort();
    };
  }, [phoneNumber, phoneIsValid]);

  useEffect(() => {
    const abortControllerBonusCard = new AbortController();
    if (bonusCard) {
      (async () => {
        try {
          const responseData = await Validate.checkBonusCard(
            bonusCard,
            abortControllerBonusCard.signal,
          );
          setBonusCardIsValid(true);
          if (responseData.formatted) {
            setBonusCard(responseData.formatted);
          }
        } catch (error) {
          const err = error as Error | AxiosError;
          if (err.name === 'AbortError') {
            // return error;
          } else {
            setBonusCardIsValid(false);
          }
        }
      })();
    }
    return () => {
      abortControllerBonusCard.abort();
    };
  }, [bonusCard, bonusCardIsValid]);

  useEffect(() => {
    const abortControllerEmail = new AbortController();
    if (email) {
      (async () => {
        try {
          const responseData = await Validate.checkEmail(email, abortControllerEmail.signal);
          if (responseData.host) {
            setEmailIsValid(true);
            setEmail(`${responseData.name}@${responseData.host}`);
          } else if (responseData[0]) {
            setEmailIsValid(true);
            setEmail(responseData[0]);
          }
        } catch (error) {
          const err = error as Error | AxiosError;
          if (err.name === 'AbortError') {
            // return error;
          } else {
            setEmailIsValid(false);
          }
        }
      })();
    }
    return () => {
      abortControllerEmail.abort();
    };
  }, [email, emailIsValid]);

  useEffect(() => {
    const abortControllerPhoneAdditional = new AbortController();
    if (additionalPhoneNumber) {
      (async () => {
        try {
          const responseData = await Validate.checkPhone(
            additionalPhoneNumber,
            abortControllerPhoneAdditional.signal,
          );
          setPhoneAdditionalIsValid(true);
          if (responseData.international) {
            setAdditionalPhoneNumber(responseData.international);
          }
        } catch (error) {
          const err = error as Error | AxiosError;
          if (err.name === 'AbortError') {
            // return error;
          } else {
            setPhoneAdditionalIsValid(false);
          }
        }
      })();
    }
    return () => {
      abortControllerPhoneAdditional.abort();
    };
  }, [additionalPhoneNumber, phoneAdditionalIsValid]);

  useEffect(() => {
    if (name) {
      (async () => {
        try {
          const responseData = await Validate.helperName(name);
          if (responseData[0]) {
            // setDataListName(responseData);
            if (responseData.length === 1) {
              setName(responseData[0]);
            }
          }
        } catch (error) {
          const err = error as Error | AxiosError;
          if (err.name === 'AbortError') {
            // return error;
          }
        }
      })();
    }
  }, [name]);

  useEffect(() => {
    if (surname) {
      (async () => {
        try {
          const responseData = await Validate.helperSurname(surname);
          if (responseData[0]) {
            // setDataListSurname(responseData);
            if (responseData.length === 1) {
              setSurname(responseData[0]);
            }
          }
        } catch (error) {
          const err = error as Error | AxiosError;
          if (err.name === 'AbortError') {
            // return error;
          }
        }
      })();
    }
  }, [surname]);

  //  useEffect(() => {
  //    if (surname || name || middlename) {
  //      const fullName = [surname, name, middlename];
  //      const fullNameAsString = String(fullName.join(' '));
  //
  //      Validate.helperName({ name: fullNameAsString, type: 'name' });
  //      dispatchAsync(fetchCheckFioValidate(fullNameAsString));
  //    }
  //  }, [surname, name, middlename]);

  //  useEffect(() => {
  //    if (name) {
  //      Validate.helperName({ name, type: 'names' });
  //      dispatchAsync(fetchCheckNameValidate(name));
  //    }
  //  }, [name]);

  //  useEffect(() => {
  //    if (surname) {
  //      Validate.helperName({ name: surname, type: 'surnames' });
  //      dispatchAsync(fetchCheckSurnameValidate(surname));
  //    }
  //  }, [surname]);

  //  useEffect(() => {
  //    if (fioHelperArray && Array.isArray(fioHelperArray) && fioHelperArray.length !== 0) {
  //      setDataList(fioHelperArray);
  //    }
  //  }, [fioHelperArray]);

  useEffect(() => {
    if (
      name ||
      surname ||
      middlename ||
      phoneNumber ||
      email ||
      company ||
      genderValue ||
      dateOfBirth
    ) {
      setProfailData({
        name: name ?? undefined,
        surname: surname ?? undefined,
        middlename: middlename ?? undefined,
        phone: phoneNumber ?? undefined,
        phone1: additionalPhoneNumber ?? undefined,
        email: email ?? undefined,
        company: company ?? undefined,
        card: bonusCard ?? undefined,
        gender: genderValue ?? undefined,
        birthday: dateOfBirth ?? undefined,
      });
    }

    if (surname && name && phoneNumber && phoneNumber.length > 15 && dateOfBirth && checkbox) {
      setDisabledButton(true);
    } else {
      setDisabledButton(false);
    }

    setErrorBoolean(Boolean(name || surname || phoneNumber || dateOfBirth));
  }, [
    name,
    surname,
    middlename,
    phoneNumber,
    email,
    company,
    checkbox,
    genderValue,
    bonusCard,
    dateOfBirth,
    additionalPhoneNumber,
  ]);

  useEffect(() => {
    if (isLogin !== null && isLogin) {
      PrivateData.getPrivateUser().then((item) => {
        setName(item.name);
        setGenderValue(item.gender);
        setMiddlename(item.middlename);
        setSurname(item.surname);
        setEmail(item.email);
        setPhoneNumber(item.phone && item.phone.international);
        setAdditionalPhoneNumber(item.phone1 && item.phone1.international);
        setCompanyValue(item.company);
        if (item.birthday) {
          // const day = item.birthday.slice(8, 10);
          // const month = item.birthday.slice(5, 7);
          // const year = item.birthday.slice(0, 5);
          // setDateOfBirth(`${month}.${day}.${year}`);
          setDateOfBirth(item.birthday);
        }
        setBonusCard(item.card && item.card.formatted);
      });
    }
  }, [isLogin]);

  useEffect(() => {
    document.title = 'Личные данные';
  }, []);

  return (
    <>
      <AppInput
        inputId="name"
        text="Имя"
        type={TEXT}
        externalClassName={personalData('field')}
        required
        handleExternal={handleSetName}
        validate="Необходимо указать Фамилию, Имя и Отчество"
        // dataListExternal={dataListName}
        valueExternal={name}
        valueBoolean={errorBoolean}
      />
      <AppInput
        inputId="surname"
        text="Фамилия"
        type={TEXT}
        externalClassName={personalData('field')}
        required
        handleExternal={handleSetSurname}
        validate="Необходимо указать Фамилию, Имя и Отчество"
        // dataListExternal={dataListSurname}
        valueExternal={surname}
        valueBoolean={errorBoolean}
      />
      <AppInput
        inputId="middlename"
        text="Отчество"
        type={TEXT}
        externalClassName={personalData('field')}
        handleExternal={handleSetMiddlename}
        valueExternal={middlename}
      />
      <AppInput
        inputId="company"
        text="Компания (не обязательно)"
        type={TEXT}
        externalClassName={personalData('field')}
        handleExternal={handleSetCompanyValue}
        placeholder="Введите название компании"
        valueExternal={company}
      />
      <RadioButtons
        data={[
          { text: 'Мужской', value: 'men' },
          { text: 'Женский', value: 'women' },
        ]}
        name="Gender"
        title="Пол"
        externalClassName={personalData('field')}
        handleExternal={handleSetGenderValue}
        valueExternal={genderValue}
      />
      <AppInput
        inputId="dateOfBirth"
        text="Дата рождения"
        type={CALENDAR}
        required
        externalClassName={personalData('field')}
        valueExternal={dateOfBirth ?? undefined}
        handleExternal={handleSetBirthDay}
        valueBoolean={errorBoolean}
      />
      <AppInput
        inputId="phoneNumber"
        text="Телефон"
        type={TEL}
        required
        externalClassName={personalData('field')}
        validate="Номер телефона не существует"
        isValidExternal={phoneIsValid}
        handleExternal={handleSetPhoneNumber}
        valueExternal={phoneNumber}
        valueBoolean={errorBoolean}
        additionalTelNumber={additionalPhone}
        handleAddetPhone={handleAddetAdditionalTel}
        personal
      />
      {additionalPhone && (
        <AppInput
          inputId="phoneNumberAdditional"
          text="Дополнительный-телефон"
          type={TEL}
          externalClassName={personalData('field')}
          validate="Номер телефона не существует"
          isValidExternal={phoneAdditionalIsValid}
          handleExternal={handleSetAdditionalPhoneNumber}
          valueExternal={additionalPhoneNumber}
          valueBoolean={errorBoolean}
          handleAddetPhone={handleAddetAdditionalTel}
          additionalInputPhoneNumber
        />
      )}
      <AppInput
        inputId="email"
        text="Электронная почта"
        type={EMAIL}
        externalClassName={personalData('field')}
        validate="E-mail адрес не существует"
        isValidExternal={emailIsValid}
        handleExternal={handleSetEmail}
        valueExternal={email ?? undefined}
      />
      <AppInput
        inputId="cashbackCard"
        text="Номер карты для получения кэшбека"
        type={TEXT}
        externalClassName={personalData('field')}
        handleExternal={handleSetBonus}
        validate="Неправильный номер карты"
        valueExternal={bonusCard}
        isValidExternal={bonusCardIsValid}
        valueBoolean={errorBoolean}
      />
      <Checkbox
        text="Я подтверждаю, что ознакомился"
        linkText=" с условиями публичной оферты"
        linkUrl="/account#service-agreement"
        externalClassName={personalData('checkbox')}
        handleExternal={handleSetCheckBox}
      />
      <Button
        handleExternal={() => handleSaveUserData()}
        text="Сохранить"
        disable={!disabledButton}
        externalClassName={personalData('button')}
      />
    </>
  );
};

export default PersonalData;
